import { SET_COMPARE_CAMPAIGNS } from '../constants/ActionTypes';

export function setCompareCampaigns(ads) {
  return { type: SET_COMPARE_CAMPAIGNS, ads };
}

export function updateCompareCampaigns(ads) {
  return { type: SET_COMPARE_CAMPAIGNS, ads };
}



// WEBPACK FOOTER //
// ./src/actions/CampaignActions.js